<template>
  <Line
    :chart-data="chartData"
    :chart-options="chartOptions"
    :width="width"
    :height="height"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from "chart.js";
import { SpeedProfile } from "@/keyboard";

const props = defineProps<{
  profile: SpeedProfile;
  width: number;
  height: number;
}>();

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
);

const getSpeed = (t: number): number => {
  if (t < props.profile.delay) {
    return 0;
  } else if (
    props.profile.acceleration_time != 0 &&
    t < props.profile.delay + props.profile.acceleration_time
  ) {
    const v0 = props.profile.start_speed;
    const v1 = props.profile.max_speed;
    const t0 = props.profile.delay;
    const dt = props.profile.acceleration_time;
    return v0 + ((v1 - v0) * (t - t0)) / dt;
  } else {
    return props.profile.max_speed;
  }
};

const data = computed(() => {
  const tEnd = Math.floor(
    (props.profile.delay + props.profile.acceleration_time) * 1.1
  );
  const time = [...Array(tEnd).keys()]; // 0..tEnd
  const speed = time.map(getSpeed);
  return { time, speed };
});

const chartData = computed(() => ({
  labels: data.value.time,
  datasets: [
    {
      data: data.value.speed,
      pointRadius: 0,
      borderColor: "rgba(74, 61, 18, 0.9)",
      borderWidth: 2,
    },
  ],
}));

const chartOptions = {
  animation: false,
  scales: {
    x: {
      title: {
        display: true,
        text: "Time [ms]",
      },
    },
    y: {
      title: {
        display: true,
        text: "Speed",
      },
    },
  },
};
</script>
